import(/* webpackMode: "eager", webpackExports: ["Root","displayName","List","Item","Trigger","Content","Link","Viewport","Indicator"] */ "/app/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"800\"],\"variable\":\"--font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticationButton"] */ "/app/src/components/auth/authentication-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorMonitorWrapper"] */ "/app/src/components/error-monitor-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoriteButtonPlaceholderContent","FavoriteListButton"] */ "/app/src/components/favorites/favorite-list-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChunkReloadCleanup"] */ "/app/src/components/layouts/chunk-reload-cleanup.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientOnlyProviders"] */ "/app/src/components/layouts/client-only-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenuSheetWrapper"] */ "/app/src/components/layouts/menu/mobile-menu-sheet-wrapper.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/scroll-reset-on-nav.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/newsletter/newsletter-small.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/hover-prefetch-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTopButton"] */ "/app/src/components/ui/scroll-to-top-button.tsx");
